import { Experience } from '../../types';
import { marginsClassNames } from '../../utils/style';

interface ExperienceProps {
  experience: Experience;
}

const formatDate = (date: Date, options?: Intl.DateTimeFormatOptions) =>
  date.toLocaleString(
    'fr-FR',
    options || {
      month: 'long',
      year: 'numeric',
    },
  );

const formatDates = (start: string, end?: string) => {
  const dateStart = new Date(start);
  if (!end) return `Depuis ${formatDate(dateStart)}`;
  const dateEnd = new Date(end);
  const formattedEnd = formatDate(dateEnd);
  const formattedStart = formatDate(dateStart, {
    month: 'long',
    year: dateEnd.getFullYear() !== dateStart.getFullYear() ? 'numeric' : undefined,
  });
  return `${formattedStart} - ${formattedEnd}`;
};

export const experienceTitleClassNames = 'mb-1 font-title text-[2.2rem] lowercase text-accent';

const Experience = ({ experience: { company, dateStart, dateEnd, description, isESN, tech, title } }: ExperienceProps) => (
  <div className="not-last:mb-10 not-print:max-desktop:not-last:mb-5">
    <div className={marginsClassNames}>
      <div className="text-center">
        <h3 className={experienceTitleClassNames}>{company}</h3>
        {title && <p className="text-sm italic">{title}</p>}
        <p className="mt-1 text-sm italic">
          {formatDates(dateStart, dateEnd)}
          {isESN ? ' (ESN)' : ''}
        </p>
      </div>
      {description?.length ? (
        <ul className="list-disc mt-4">
          {description.map((p, index) => (
            <li key={index}>{p}</li>
          ))}
        </ul>
      ) : null}
    </div>
    {tech?.length ? (
      <div className="flex flex-wrap justify-center gap-2 mt-6">
        {tech.map((t) => (
          <span key={t} className="px-2 pt-1 pb-[0.3rem] bg-page-darker text-sm lowercase">
            {t}
          </span>
        ))}
      </div>
    ) : null}
  </div>
);

export default Experience;
